export default __webpack_public_path__ + "c9236e9920ba6197f9ea8c4a9111e20f.jpg";